import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";

export interface FormDataReducerState {
  additionalConfigData: Record<string, any>;
  stepOneData: Record<string, any> | null;
  stepTwoData: Record<string, any> | null;
}

const defaultState: FormDataReducerState = {
  additionalConfigData: {},
  stepOneData: null,
  stepTwoData: null,
};

export const formDataSlice = createSlice({
  name: 'formData',
  initialState: defaultState,
  reducers: {
    setAdditionalConfigData: (state, action: PayloadAction<Record<string, any>>) => {
      state.additionalConfigData = { ...state.additionalConfigData, ...action.payload };
    },
    clearAdditionalConfigData: (state) => {
      state.additionalConfigData = {};
    },
    setStepOneData: (state, action: PayloadAction<Record<string, any> | null>) => {
      state.stepOneData = action.payload;
    },
    setStepTwoData: (state, action: PayloadAction<Record<string, any> | null>) => {
      state.stepTwoData = action.payload;
    },
    clearFormData: (state) => {
      state.additionalConfigData = {};
      state.stepOneData = null;
      state.stepTwoData = null;
    },
  },
});

export const {
  setAdditionalConfigData,
  clearAdditionalConfigData,
  setStepOneData,
  setStepTwoData,
  clearFormData,
} = formDataSlice.actions;

export const selectAdditionalConfigData = (state: RootState) => (state.formData as FormDataReducerState).additionalConfigData;
export const selectStepOneData = (state: RootState) => (state.formData as FormDataReducerState).stepOneData;
export const selectStepTwoData = (state: RootState) => (state.formData as FormDataReducerState).stepTwoData; 